export const adminMode = () => {
  return (
    JSON.parse(atob(localStorage.getItem('cat') || window.$cookies.get('cat')))
      .role === 'admin'
  )
}

export const fetchCat = () => {
  const cookie = window.$cookies.get('cat') || localStorage.getItem('cat')
  if (cookie) {
    return JSON.parse(atob(cookie))
  }
  return null
}
